import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import LocaleStrings from '@language';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css
// Import Action
import {
  showNotificatonCount,
  isNotificationModalOpen,
  onSidebarMenuSelected,
} from '@sidebarActions';
// Common Functions
import toast, { Toaster } from 'react-hot-toast';
import UpgradePricing from '@upgradePricing';
import { fetchAppuser } from '@sidebarActions';
import { fetchCurrentMemberCount, fetchApikeyCount } from '@upgradePlanActions';

class UpgradePlan extends Component {
  constructor(props) {
    super(props);

    this.state = {};

    // All Binded Functions
  }

  componentDidMount() {
    let { session, user } = this.props;
    this.props.fetchAppuser(session, user.appuserid, callback => {
      this.props.fetchCurrentMemberCount(session, callback => {
        this.props.fetchApikeyCount(session, callback => { });
      });
    });
  }

  render() {
    let { appuserData } = this.props;
    let role = '';
    if (appuserData && appuserData.data && appuserData.data.length) {
      role = appuserData.data[0].role;
    }
    return (
      <>
        {role == 'client' ? (
          <div
            className="flex overflow-hidden bg-quaternary"
            style={{ height: 'calc(100vh / var(--zoom))' }}>
            <div className="flex flex-col w-0 flex-1 overflow-hidden">
              {/* <main
                className="main-tag-class- xs:px-6 sm:px-12 lg:px-12 py-10 overflow-y-auto bg-homegray scrollbar-hide"
                style={{height: 'calc(100vh / var(--zoom) - 40px)'}}>
                <UpgradePricing history={this.props.history} />
                <Toaster />
              </main> */}
             <div
  className="flex flex-col items-center justify-center "
  style={{ height: 'calc(100vh / var(--zoom) - 40px)' }}
>
  {/* Back Button */}
  <button
    onClick={() => {
      this.props.history.push('/main/dashboardmain');
    }}
    className="mb-6 inline-block bg-gray-700 hover:bg-gray-800 text-white font-semibold px-6 py-2 rounded-full shadow-md transition-all duration-300"
  >
    ⬅️ Back to Dashboard
  </button>

  {/* Payment Notice Card */}
  <div className="max-w-2xl w-full mx-4 p-10 bg-white shadow-2xl rounded-3xl text-center transform hover:scale-[1.02] transition-all duration-300">
    <h2 className="text-4xl font-bold text-gray-800 mb-5">
      💳 Payments Not Available
    </h2>
    <p className="text-lg text-gray-600 leading-relaxed mb-8">
  We are currently{" "}
  <span className="font-semibold text-gray-800">not accepting any payments</span> in{" "}
  <span className="text-indigo-600 font-semibold">Phase 1</span>.
  <br className="hidden sm:block" />
  Please visit{" "}
  <a
    href="https://phase2.kipplo.com"
    target="_blank"
    rel="noopener noreferrer"
    className="text-indigo-600 hover:text-indigo-700 underline font-semibold"
  >
    Phase 2
  </a>{" "}
  or{" "}
  <a
    href="mailto:support@kipplo.com"
    className="text-blue-600 hover:text-blue-700 underline font-medium"
  >
    contact us
  </a>{" "}
  for assistance.
</p>


    {/* <div className="flex justify-center">
      <a
        href="mailto:support@kipplo.com"
        className="inline-block bg-indigo-600 hover:bg-indigo-700 text-white font-semibold px-8 py-3 rounded-full shadow-md transition-all duration-300"
      >
        Contact Support
      </a>
    </div> */}
  </div>
</div>


            </div>
          </div>
        ) : (
          ''
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  var { session, user } = state;
  return {
    session,
    user,
    isLoggedIn: state.isLoggedIn,
    appuserData: state.appuserData,
  };
}

export default connect(mapStateToProps, {
  onSidebarMenuSelected,
  showNotificatonCount,
  isNotificationModalOpen,
  fetchAppuser,
  fetchCurrentMemberCount,
  fetchApikeyCount,
  // selectedProfileSettingsMenu,
})(UpgradePlan);
